import React from 'react';
import {useGetSkillsQuery} from '../../api/candidate';
import SelectField, {SelectFieldHookForm} from '../ui/SelectField';

const SkillDropdown = ({
  type = null,
  optionsWithId = null,
  control = null,
  ...restProps
}) => {
  const {data: skillData, isFetching: isSkillLoading} = useGetSkillsQuery();

  let skillOptions = [];

  (skillData?.data || []).forEach(({name, _id, type: skillType}) => {
    const payload = {
      value: optionsWithId ? _id : name,
      label: name,
    };

    if (type) {
      if (skillType === type) {
        skillOptions.push(payload);
      }
    } else {
      skillOptions.push(payload);
    }
  });

  return (
    <>
      {!control && (
        <SelectField
          options={skillOptions}
          isLoading={isSkillLoading}
          {...restProps}
        />
      )}

      {control && (
        <SelectFieldHookForm
          options={skillOptions}
          isLoading={isSkillLoading}
          control={control}
          {...restProps}
        />
      )}
    </>
  );
};

export default SkillDropdown;
